var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit }) {
          return [
            _c(
              "form",
              {
                staticClass: "login-form custom-form",
                attrs: {
                  id: "login-form",
                  novalidate: "",
                  "data-testid": "login-form"
                },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return handleSubmit(_vm.onSubmit)
                  }
                }
              },
              [
                _c("ValidationProvider", {
                  attrs: { mode: "lazy", rules: "required|email" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c(
                              "fieldset",
                              {
                                staticClass: "login-form__field input__wrap",
                                class: { "error-focus": errors.length > 0 }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.email,
                                      expression: "email"
                                    }
                                  ],
                                  ref: "userNameInput",
                                  staticClass:
                                    "login-form__field__input required",
                                  class: {
                                    error: errors.length > 0,
                                    valid:
                                      _vm.email.length > 0 && errors.length == 0
                                  },
                                  attrs: {
                                    id: "userName",
                                    disabled: _vm.isPending,
                                    type: "email",
                                    name: "userName",
                                    "data-testid": "email-input",
                                    required: ""
                                  },
                                  domProps: { value: _vm.email },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) return
                                      _vm.email = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", {
                                  directives: [
                                    {
                                      name: "t",
                                      rawName: "v-t",
                                      value: "INPUT_EMAIL",
                                      expression: "'INPUT_EMAIL'"
                                    }
                                  ],
                                  staticClass: "login-form__field__label",
                                  attrs: { for: "userName" }
                                }),
                                _vm._v(" "),
                                errors.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "error-tooltip__wrap",
                                        attrs: { "data-testid": "email-error" }
                                      },
                                      [
                                        _c("h4", {
                                          directives: [
                                            {
                                              name: "t",
                                              rawName: "v-t",
                                              value: "INPUT_EMAIL_ERROR",
                                              expression: "'INPUT_EMAIL_ERROR'"
                                            }
                                          ],
                                          staticClass:
                                            "menu-link text-uppercase error-tooltip__content"
                                        }),
                                        _vm._v(" "),
                                        _c("p", {
                                          directives: [
                                            {
                                              name: "t",
                                              rawName: "v-t",
                                              value:
                                                "INPUT_EMAIL_ERROR_DESCRIPTION",
                                              expression:
                                                "'INPUT_EMAIL_ERROR_DESCRIPTION'"
                                            }
                                          ],
                                          staticClass: "description"
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("ValidationProvider", {
                  attrs: { mode: "lazy", rules: "required" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c(
                              "fieldset",
                              {
                                staticClass:
                                  "login-form__field input__wrap password__wrap",
                                class: { "error-focus": errors.length > 0 }
                              },
                              [
                                _vm.passwordType === "checkbox"
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.password,
                                          expression: "password"
                                        }
                                      ],
                                      ref: "passwordInput",
                                      staticClass:
                                        "login-form__field__input password-has-icon required",
                                      class: {
                                        error: errors.length > 0,
                                        valid:
                                          _vm.password.length > 0 &&
                                          errors.length == 0
                                      },
                                      attrs: {
                                        id: "password",
                                        disabled: _vm.isPending,
                                        name: "password",
                                        "data-testid": "password-input",
                                        required: "",
                                        type: "checkbox"
                                      },
                                      domProps: {
                                        checked: Array.isArray(_vm.password)
                                          ? _vm._i(_vm.password, null) > -1
                                          : _vm.password
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = _vm.password,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.password = $$a.concat([
                                                  $$v
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.password = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.password = $$c
                                          }
                                        }
                                      }
                                    })
                                  : _vm.passwordType === "radio"
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.password,
                                          expression: "password"
                                        }
                                      ],
                                      ref: "passwordInput",
                                      staticClass:
                                        "login-form__field__input password-has-icon required",
                                      class: {
                                        error: errors.length > 0,
                                        valid:
                                          _vm.password.length > 0 &&
                                          errors.length == 0
                                      },
                                      attrs: {
                                        id: "password",
                                        disabled: _vm.isPending,
                                        name: "password",
                                        "data-testid": "password-input",
                                        required: "",
                                        type: "radio"
                                      },
                                      domProps: {
                                        checked: _vm._q(_vm.password, null)
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.password = null
                                        }
                                      }
                                    })
                                  : _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.password,
                                          expression: "password"
                                        }
                                      ],
                                      ref: "passwordInput",
                                      staticClass:
                                        "login-form__field__input password-has-icon required",
                                      class: {
                                        error: errors.length > 0,
                                        valid:
                                          _vm.password.length > 0 &&
                                          errors.length == 0
                                      },
                                      attrs: {
                                        id: "password",
                                        disabled: _vm.isPending,
                                        name: "password",
                                        "data-testid": "password-input",
                                        required: "",
                                        type: _vm.passwordType
                                      },
                                      domProps: { value: _vm.password },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.password = $event.target.value
                                        }
                                      }
                                    }),
                                _vm._v(" "),
                                _c("label", {
                                  directives: [
                                    {
                                      name: "t",
                                      rawName: "v-t",
                                      value: "INPUT_PASSWORD",
                                      expression: "'INPUT_PASSWORD'"
                                    }
                                  ],
                                  staticClass: "login-form__field__label",
                                  attrs: { for: "password" }
                                }),
                                _vm._v(" "),
                                _c("a", {
                                  staticClass: "icon--password fa fa-eye",
                                  attrs: {
                                    "data-testid": "toggle-password-visibility"
                                  },
                                  on: { click: _vm.showPassword }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "error-tooltip__wrap",
                                    attrs: { "data-testid": "password-error" }
                                  },
                                  [
                                    _c("h4", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "INPUT_PASSWORD_ERROR",
                                          expression: "'INPUT_PASSWORD_ERROR'"
                                        }
                                      ],
                                      staticClass:
                                        "menu-link text-uppercase error-tooltip__content"
                                    }),
                                    _vm._v(" "),
                                    _c("p", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value:
                                            "INPUT_PASSWORD_ERROR_DESCRIPTION",
                                          expression:
                                            "'INPUT_PASSWORD_ERROR_DESCRIPTION'"
                                        }
                                      ],
                                      staticClass: "description xxs-visible"
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c(
                  "fieldset",
                  {
                    staticClass:
                      "login-form__field login-form__field--checkbox checkbox__wrap"
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.remember,
                          expression: "remember"
                        }
                      ],
                      staticClass: "login-form__field__input--checkbox",
                      attrs: {
                        id: "login.checkbox",
                        type: "checkbox",
                        name: "signup.checkbox",
                        "data-testid": "remember-me-checkbox"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.remember)
                          ? _vm._i(_vm.remember, null) > -1
                          : _vm.remember
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.remember,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.remember = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.remember = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.remember = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "INPUT_REMEMBER_ME",
                          expression: "'INPUT_REMEMBER_ME'"
                        }
                      ],
                      staticClass:
                        "login-form__field__label login-form__field__label--checkbox",
                      attrs: { for: "login.checkbox" }
                    }),
                    _vm._v(" "),
                    _c("a", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "FORGOT_PASS_LINK",
                          expression: "'FORGOT_PASS_LINK'"
                        }
                      ],
                      staticClass: "forget-pass-link",
                      attrs: {
                        id: "forget-pass-link",
                        href: "#",
                        "data-testid": "forgot-password-link"
                      },
                      on: { click: _vm.forgotPassword }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "fieldset",
                  {
                    staticClass: "login-form__field login-form__field--button"
                  },
                  [
                    _c(
                      "SubmitButton",
                      {
                        attrs: {
                          pending: _vm.isPending,
                          "data-testid": "login-button"
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("LOGIN_BUTTON")) +
                            " \n      "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("transition", { attrs: { name: "backend-error-fade" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showErrorMsg,
                          expression: "showErrorMsg"
                        }
                      ],
                      staticClass: "text-center p-t-5",
                      attrs: { "data-testid": "backend-error-message" }
                    },
                    [
                      _c("p", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.actionStatus.error) +
                            "\n        "
                        )
                      ])
                    ]
                  )
                ])
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }